module.exports = __webpack_public_path__ + "sunsemweb/img/footlogo.7977eff3.png";